export const SOCKET_SERVER = process.env.REACT_APP_SOCKET_SERVER
